// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.suggestionContainer {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.suggestionContainer img {
  width: 15%;
}
.suggestionContainer .suggestionTextContainer {
  display: flex;
  align-items: center;
  height: 100%;
  width: 85%;
}

.principal-img {
  display: block;
  width: 50%;
  margin: 0 auto;
}

.paginador-img {
  display: block;
  margin: 0 auto;
}

.iframe-container {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
}
.iframe-container .white-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  width: 80%;
  height: 95%;
}
.iframe-container .white-container .iframe {
  width: 100%;
  height: 100%;
}
@media (max-width: 768px) {
  .iframe-container .white-container {
    width: 100%;
    height: 100%;
  }
}

@media (max-width: 480px), (min-width: 915px) and (max-width: 1024px) {
  .suggestionContainer img {
    width: 25%;
  }
  .suggestionContainer .suggestionTextContainer {
    width: 75%;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
